import { formatDate } from "../LedgerResponsive";

export const transactionColumns = (openModal) => [
  {
    title: "Tran Date",
    dataIndex: "tran_date",
    key: "tran_date",
    render: (v) => formatDate(v),
  },
  {
    title: "NAV Date",
    dataIndex: "nav_date",
    key: "nav_date",
    render: (v) => formatDate(v),
  },
  {
    title: "Tran No",
    dataIndex: "tran_no",
    key: "tran_no",
    render: (text, record) =>
      openModal ? (
        <button
          style={{
            padding: 0,
            border: "none",
            background: "none",
            color: "#1677ff",
            cursor: "pointer",
          }}
          onClick={() => openModal(record)}
        >
          {text}
        </button>
      ) : (
        text
      ),
  },
  {
    title: "Units",
    dataIndex: "units",
    key: "units",
    render: (v) => Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 4 }),
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (v) => `₹${Number(v || 0).toLocaleString()}`,
  },
  {
    title: "NAV",
    dataIndex: "nav",
    key: "nav",
    render: (v) => Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2 }),
  },
  {
    title: "Type",
    dataIndex: "tran_sign",
    key: "tran_sign",
  },
  {
    title: "Balance Units",
    dataIndex: "balance_units",
    key: "balance_units",
    render: (v) =>
      v != null ? Number(v).toLocaleString(undefined, { minimumFractionDigits: 4 }) : "-",
  },
];
